import { FC } from 'react'
import styled from 'styled-components'
import Config from '../managers/Config'

const VersionDiv = styled.div`
  position: absolute;
  bottom: 75px;
  right: 10px;
  opacity: .5;
  font-size: .5625rem;
  color: transparent;
`

const Version: FC = () => <VersionDiv>v. {Config.version}</VersionDiv>

export default Version